<template>
  <a-tooltip
    :title="isTruncated ? value : null"
    placement="topLeft"
    :overlayStyle="overlayStyle"
  >
    <div
      ref="textRef"
      class="hide-long-text"
      :class="{ 'is-truncated': isTruncated }"
      @click="onClick"
    >
      {{ value || '-' }}
    </div>
  </a-tooltip>
</template>

<script>
export default {
  name: 'HideLongText',
  props: {
    value: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isTruncated: false,
    }
  },
  computed: {
    overlayStyle() {
      return {
        maxWidth: '300px',
        maxHeight: '300px',
        overflowY: 'auto',
      }
    },
  },
  methods: {
    checkTruncate() {
      const el = this.$refs.textRef
      if (!el) {
        return
      }

      this.isTruncated = el.scrollWidth > el.clientWidth
    },
    onClick() {
      this.action()
    },
  },
  mounted() {
    this.checkTruncate()
    window.addEventListener('resize', this.checkTruncate)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkTruncate)
  },
}
</script>

<style scoped>
.hide-long-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hide-long-text.is-truncated {
  cursor: context-menu;
}
</style>
